import { defaultLanguage, type Language } from '../constants/lang'

export const retrieveLanguage = (): Language => {
  return localStorage.getItem('language') as Language ?? defaultLanguage
}

export const storeLanguage = (lang: Language): void => {
  localStorage.setItem('language', lang)
}
